import React, { useState, useCallback, Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Box, Grid, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';

const emptyHtmlJson = {
    "elementName": "div",
    "name": "screen",
    "style": {
        "position": "relative",
        "width": 375,  //보더 사이즈가 4px 추가됨
        "height": 600,
        "whiteSpace": "nowrap",
        "lineHeight": "normal"
    },
    "attribute": {
        "className": "cl stacommon",
        "clname": "screen"
    },
    "childElements": [],
    "udid": null,
    "depth": 0
}


const BlockViewer = props => {
    const [loading, setLoading] = useState(true);
    const [cloudHtmlJson, setCloudHtmlJson] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [selectingNodeList, setSelectingNodeList] = React.useState([]);

    useEffect(() => {
        if (props.block_id) {
            setLoading(true)
            client.request_get(`/block/${props.block_id}`).then(res => {
                setLoading(false)
                setCloudHtmlJson(res.cloud_html_json)
            }).catch(e => {
            })
        }
    }, [ props.block_id])

    const getDivNode = (j, clickable, depth) => {
        const boder_styles = {
            border: '0px solid rgba(0, 0, 0, 0.1)',
        };
        return (
            <div key={j && j.name ? j.name : '1'} style={depth == 0 ? { ...j.style, ...boder_styles } : j.style}
                onMouseEnter={(e) => {
                    if (!clickable)
                        return
                    if (j.depth > 0) {
                        if (j.depth == 1)
                            e.currentTarget.style.border = `1px solid red`
                        else if (j.depth == 2)
                            e.currentTarget.style.border = `1px solid green`
                        else if (j.depth == 3)
                            e.currentTarget.style.border = `1px solid blue`
                        else if (j.depth == 4)
                            e.currentTarget.style.border = `1px solid yellow`
                        else if (j.depth == 5)
                            e.currentTarget.style.border = `1px solid purple`
                        e.currentTarget.style.borderOffset = '-1px'
                    }
                }}
                onMouseLeave={(e) => {
                    if (!clickable)
                        return
                    if (j.depth > 0) {
                        e.currentTarget.style.border = '0px'
                        e.currentTarget.style.borderOffset = '0px'
                    }
                }}

                onClick={e => {
                    if (!clickable)
                        return
                    let s = selectingNodeList;
                    if (s.filter(m => m.udid == j.udid).length == 0) {
                        s.push({ name: j.name, udid: j.udid })
                    }
                    if (s.length == 1)
                        setAnchorEl(e.currentTarget)
                    setSelectingNodeList(s)
                }}>
                {j.elementName == 'img' && <img src={j.src} style={{ width: '100%', height: '100%' }} />}
                {j.innerText && <div style={{
                    position: 'absolute', width: '100%',
                    ...(j.valignment == 1 && { transform: 'translateY(-50%)', top: '50%' })
                }}>{j.innerText}</div>}
                {j && j.childElements && j.childElements.map(m =>
                    getDivNode(m, clickable, depth + 1)
                )}
            </div>
        )
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
        setSelectingNodeList([])
    };

    const handleCopyUdid = (e) => {
        alert(e)
    };

    return (
        <Grid
            borderColor="grey.500"
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
        >
            <Grid item xs={12}>
                {props.showEditButton &&
                    <Box m={1}>
                        <Link to={`/block/${props.block_id}`}>
                            <Button variant="outlined" color="primary">Edit Block</Button>
                        </Link>
                    </Box>
                }
                <Box alignItems="center"
                    justify="center">
                    {loading && <div style={{position: 'absolute', 
                        justifyContent: 'center', justify:'center', alignItems:"center", display: 'flex',
                        width:'380px', height:'620px', }}>
                        <CircularProgress size={40} />
                    </div>}
                    {!loading && cloudHtmlJson && getDivNode(cloudHtmlJson, props.clickable, 0)}
                    {loading && getDivNode(emptyHtmlJson, false, 0)}
                    {!loading && !cloudHtmlJson && 'Please, set Sketch Root'}
                </Box>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    {selectingNodeList.map(m =>
                        <MenuItem key={m.name}>
                            <Typography>{m.name}</Typography>
                            &nbsp;
                            <Button onClick={e => { handleCopyUdid(m.udid) }}
                                variant="outlined" color="primary" >Copy Udid</Button>
                        </MenuItem>
                    )}

                </Popover>
            </Grid>
        </Grid>
    );
};

export default BlockViewer;
